import React from 'react';

import styled from '@emotion/styled';

import PageBanner from '../../../components/Banner/PageBanner';
import ApplicationSegment from './ApplicationSegment/ApplicationSegment';
import { useNavigate } from 'react-router';
import LeftTriangleIcon from '../../../components/Icons/LeftTriangleIcon';
import { DASHBOARD } from '../../../routes/routeConstants';
import Page from '../../../components/Page/Page';

const Application = () => {
  const navigate = useNavigate();

  return (
    <Page title="Locumspace | Applications">
      <Container>
        <PageBanner
          label="Applications"
          description="Welcome to your application dashboard"
        />{' '}
        <NavigationArea onClick={() => navigate(`/${DASHBOARD}`)}>
          <LeftTriangleIcon />
          Back to Dashboard
        </NavigationArea>
        <ApplicationSegment />
      </Container>
    </Page>
  );
};

export default Application;

const Container = styled.section`
  display: flex;
  gap: 10px;
  flex-direction: column;
  margin-bottom: 54px;
`;

const NavigationArea = styled.div`
  display: flex;
  align-items: center;
  font-size: 18px;
  color: #2f80ed;
  font-weight: 500;
  cursor: pointer;
  width: fit-content;

  & > svg {
    transition: transform 0.3s ease-in-out;
    transform: translateX(0);
  }

  &:hover > svg {
    transform: translateX(-8px);
  }
`;
